module.exports = __webpack_public_path__ + "img/2.e9aa18fd.jpg";